import { ChevronIcon } from '@insta-club/components/icons';
import { Container } from '@insta-club/components/layout';
import Link from 'next/link';

interface IProps extends React.PropsWithChildren {
    title: string;
    link?: {
        title: string;
        href: string;
    };
}

function ContentWrapper({ children, title, link }: IProps) {
    return (
        <div className='mt-8'>
            <Container>
                <div className='mb-4 flex items-center justify-between'>
                    <span className='text-base font-semibold text-gray-800'>{title}</span>
                    {link && (
                        <Link href={link.href} className='text-primary-500 flex items-center text-sm font-semibold'>
                            {link?.title}
                            <ChevronIcon className='mr-2' />
                        </Link>
                    )}
                </div>
            </Container>

            {children}
        </div>
    );
}

export default ContentWrapper;

